import { Link, useNavigate } from 'react-router-dom';
// Images
import iaIcon_1 from '../../Images/ia/iaIcon_1.svg';
import iaIcon_2 from '../../Images/ia/iaIcon_2.svg';
import logoAquinas from '../../Images/logo/logo_OlibBlack.svg';
// Component
import Info from '../../Components/Info';
import Container from '../../Components/Container';
import IASearchBar from '../../Components/IASearchBar';
// Icons
import { IoIosArrowBack } from 'react-icons/io';
// Styles
import './IAInit.css';
import { t } from 'i18next';

const IAInit = ({ setSearchBarHeight }) => {
  const navigate = useNavigate();

  return (
    <main className='iaInit'>
      <Container className='iaInitContainer'>
        <div className='iaContainerButtons'>
          <button
            className='goBackButton'
            onClick={() => navigate('/articles')}
          >
            <IoIosArrowBack />
            <p>{t('Go back')}</p>
          </button>
          <Info />
        </div>
        <div className='iaContainerInfo'>
          <Link to='/'>
            <img src={logoAquinas} alt='logo Aquinas' />
          </Link>

          <div className='iaContainerInfo__text'>
            <h1>{t("Hello! I'm Aquino, your new virtual study partner")}</h1>
            <p>
              {t('Do you have any questions about a particular topic?')}{' '}
              <b>
                {t(
                  'Please let me know when you would like to switch topics so I can offer you more accurate results'
                )}
              </b>{' '}
              {t('Remember, while I am a powerful tool')}
            </p>
          </div>
          <div className='iaContainerInfo__cards'>
            <div className='iaCardInit'>
              <img src={iaIcon_1} alt='icon book' />
              <p>
                {t(
                  'Make searches in libraries from different sources and topics in seconds'
                )}
              </p>
            </div>
            <div className='iaCardInit'>
              <img src={iaIcon_2} alt='icon searxh' />
              <p>
                {t('Make quick searches in a variety of specialized articles')}
              </p>
            </div>
          </div>
        </div>
        <div className='iaContainerSearch'>
          <IASearchBar setSearchBarHeight={setSearchBarHeight} />
          <p>
            {t(
              'This assistant can provide automated responses. Always verify key information before making decisions'
            )}
          </p>
        </div>
      </Container>
    </main>
  );
};

export default IAInit;
